/* eslint-disable @typescript-eslint/no-unused-vars */
import {} from "hooks";
import useDebugAction from "hooks/useDebugAction";
import { Fragment, useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { IWebStoreGeneralErrorResponse } from "../../contexts/WebStoreProvider/types";
import SetDebugActionDialog from "./SetDebugActionDialog";
import { useDialogModalRedux } from "redux/slices/dialog/hooks/useDialogModalRedux";
import { WsDialogs as IDialogVariants } from "interfaces/dialog/variant";

export const DebugActions: React.FC = ({ children }) => {
	const { isSetting, isSuccess, isError, error, isNormalFlow, isLoggedIn } =
		useDebugAction();
	const location = useLocation();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const pendingDebugAction = localStorage.getItem(
		"store.solitairetripeaks.com:debugAction"
	);
	const { openDialog } = useDialogModalRedux();

	useEffect(() => {
		if (!isLoggedIn && pendingDebugAction) {
			openDialog(IDialogVariants.LOGIN_TO_CONNECT, {
				source: "debug-actions"
			});
		}
	}, [isLoggedIn, pendingDebugAction]);

	useEffect(() => {
		if (isSuccess) {
			if (searchParams.has("debugactionid")) {
				searchParams.delete("debugactionid");
				const params = searchParams.toString();
				const newUrl = params
					? `${location.pathname}?${params}`
					: location.pathname;
				window.location.replace(newUrl);
			}
		}
	}, [isSuccess]);

	if (isSetting) {
		return (
			<div style={{ color: "blue", marginLeft: "5px" }}>
				Executing Debug Action...
			</div>
		);
	}

	if (isSuccess) {
		return (
			<div style={{ color: "green", marginLeft: "5px" }}>
				Success Executing Debug Action
			</div>
		);
	}

	if (isError) {
		const generalError = error as IWebStoreGeneralErrorResponse;
		return (
			<div style={{ color: "red", marginLeft: "5px" }}>
				Error Executing Debug Action: {generalError?.data?.errorMessage}
			</div>
		);
	}

	if (!isNormalFlow) {
		return null;
	}

	return (
		<Fragment>
			{pendingDebugAction && isLoggedIn && <SetDebugActionDialog />}
			{children}
		</Fragment>
	);
};
